import { render, staticRenderFns } from "./OrderListItemActionsControls.vue?vue&type=template&id=04e5c9f4&scoped=true"
import script from "./OrderListItemActionsControls.vue?vue&type=script&lang=js"
export * from "./OrderListItemActionsControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e5c9f4",
  null
  
)

export default component.exports